<template>
  <section class="project-step__navigator">
    <div class="step__navigator--desktop">
      <div>
        <router-link v-if="active === 1" :to="{name: 'ProjectList'}">
          <rum-button tertiary>
            <span class="step-navigator--above-tablet">
              <i style="margin-right:var(--spacing-3); margin-top: 2px;" class="fas fa-arrow-left"></i>Project List
            </span>
            <span class="step-navigator--tablet">
              <i class="fas fa-arrow-left"></i>
            </span>
          </rum-button>
        </router-link>
        <rum-button tertiary @click="$emit('prev')" v-else>
          <span class="step-navigator--above-tablet">
            <i style="margin-right:var(--spacing-3); margin-top: 2px;" class="fas fa-arrow-left"></i>Back
          </span>
          <span class="step-navigator--tablet">
            <i class="fas fa-arrow-left"></i>
          </span>
        </rum-button>
      </div>

      <div>
        <div v-if="active===1" v-html="messages.step1" class="step-navigator__content"></div>
        <div v-if="active===2" class="step-navigator__content">{{messages.step2}}</div>
        <div v-if="active===3" class="step-navigator__content">{{messages.step3}}</div>
      </div>

      <div>
        <rum-button secondary v-show="active === 2 || active === 1" @click="$emit('next')">
          <span class="step-navigator--above-tablet">
            Next Step
            <i style="margin-left:var(--spacing-3); margin-top: 2px;" class="fas fa-arrow-right"></i>
          </span>
          <span class="step-navigator--tablet">
            <i class="fas fa-arrow-right"></i>
          </span>
        </rum-button>

        <rum-button secondary v-show="active === 3" @click="deployApp" >
          <span
            class="step-navigator--above-tablet"
            style="padding-left: 20px; padding-right: 20px; padding-bottom: 1px;padding-top: 1px;">
            <span>Deploy App</span>
          </span>
          <span class="step-navigator--tablet">
            <i class="fas fa-bolt"></i>
          </span>
        </rum-button>
      </div>
    </div>

    <div class="step__navigator--mobile">
      <div>
        <div>
          <div v-if="active===1" v-html="messages.step1" class="step-navigator__content"></div>
          <div v-if="active===2" class="step-navigator__content">{{messages.step2}}</div>
          <div v-if="active===3" class="step-navigator__content">{{messages.step3}}</div>
        </div>
      </div>

      <div class="step-navigator__steps">
        <div>
          <router-link v-show="active === 1" :to="{name: 'ProjectList'}">
            <rum-button tertiary>
              <span>
                <i class="fas fa-arrow-left"></i>
              </span>
            </rum-button>
          </router-link>
          <rum-button tertiary v-show="active === 2 || active === 3" @click="$emit('prev')">
            <span>
              <i class="fas fa-arrow-left"></i>
            </span>
          </rum-button>
        </div>

        <div>
          <rum-button secondary v-show="active === 2 || active === 1" @click="$emit('next')">
            <span>
              <i class="fas fa-arrow-right"></i>
            </span>
          </rum-button>
          <rum-button secondary v-show="active === 3" @click="deployApp" >
            <span class="step-navigator--tablet">
              <i class="fas fa-bolt"></i>
            </span>
          </rum-button>
        </div>
      </div>
    </div>
  </section>
</template>


<script>
export default {
  props: {
    project: Object,
    active: {
      type: Number,
      default: 1
    }
  },
  computed: {
    messages() {
      return {
        step1: "Setup and customize your Learn Project.",
        step2: "Influence the category areas of the Bytes that will be delivered in your Project.",
        step3: "Create custom Byte channel pages for your Project."
      };
    },
  },
  methods: {
    deployApp() {
      this.$modal.show("deploy-app-modal", { project: this.project });
    },
  }
};
</script>

<style scoped>
.project-step__navigator {
  display: flex;
  justify-content: space-between;
  padding: var(--spacing-4);
  background-color: var(--white);
  margin: var(--spacing-4);
  margin-top: 0;
  align-items: baseline;
  box-shadow: var(--shadow-bottom);
}

.step__navigator--desktop {
  display: contents;
}

.step__navigator--mobile {
  display: none;
}

.step-navigator--tablet {
  display: none;
}

.step-navigator__content {
  text-align: center;
  padding: var(--spacing-4);
  max-width: 800px;
  font-size: var(--md);
  line-height: var(--spacing-5);
  color: var(--grey-darkest);
}

.step-navigator__badge {
  display: flex;
  justify-content: center;
  margin-top: var(--spacing-3);
}

.sync-indicator__badge {
  margin-left: var(--spacing-2);
}

.badge {
  /* border-radius:var(--spacing-16); */
}

.step-navigator--above-tablet {
  display: flex;
  align-items: center;
  font-weight: normal;
}

@media screen and (max-width: 1000px) {
  .project-step__navigator {
    border-top: var(--border-2) solid var(--grey-lighter);
  }

  .step-navigator--above-tablet {
    display: none;
  }

  .step-navigator__content {
    font-size: var(--sm);
    text-align: center;
    padding: var(--spacing-4);
  }

  .step-navigator--tablet {
    display: block !important;
  }
}

@media screen and (max-width: 650px) {
  .project-step__navigator {
    flex-direction: column;
  }

  .step-status__badge {
    margin-top: var(--spacing-2);
  }

  .step__navigator--desktop {
    display: none;
  }

  .step__navigator--mobile {
    display: block;
    width: 100%;
  }

  .step-navigator__steps {
    display: flex;
    justify-content: space-between;
    margin-top: var(--spacing-2);
  }

  .step-navigator--tablet {
    display: block;
  }

  .step-navigator__badge {
    flex-direction: column;
    align-items: center;
  }

  .sync-indicator__badge {
    margin-top: var(--spacing-2);
  }
}
</style>
